<template>
    <div>
        <v-autocomplete
                v-model="step"
                :items="steps"
                :item-value="byName ? 'name': 'id'"
                item-text="name"
                outlined
                dense
                :readonly="readonly"
                :disabled="disabled"
                :clearable="!(readonly || notClearable)"
                :label="label"
                :loading="loading"
                :color="inputColor"
                :background-color="backgroundColor"
                @input="$emit('input', step)"
                hide-details="auto"
                :rules="rules"
        ></v-autocomplete>
        <input type="hidden">
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import axios from "axios";

export default {
    name: 'StrStepSelect',
    props: {
        value: [Number, String],
        module: String,
        label: String,
        byName: Boolean,
        exceptFinal: Boolean,
        readonly: Boolean,
        disabled: Boolean,
        notClearable: Boolean,
        rules: Array,
    },
    setup(props) {
        const {inputColor, backgroundColor, loading} = useSharedData();

        const step = ref(null);
        const steps = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/validationWorkFlows/steps/${props.module}`).then(response => {
                for (const key in response.data) {
                    if (Object.prototype.hasOwnProperty.call(response.data, key)) {
                        const item = {
                            id: key,
                            name: response.data[key]
                        };
                        steps.value.push(item);
                    }
                }
            }).finally(() => {
                loading.value = false;
            })
        }

        watch(() => props.value, () => {
            step.value = props.value;
        }, {immediate: true});

        onMounted(() => {
            findAll();
        })

        return {
            inputColor,
            backgroundColor,
            loading,
            step,
            steps,
        }
    },
}
</script>